module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<form id="merchant-login-form" autocomplete="off" class="' +
((__t = ( data.isPazienUser ? "pazien-user" : "unknown-user")) == null ? '' : __t) +
'">\n    <div id="login-status" class="alert alert-danger hidden" role="alert"></div>\n    ';
 if (data.showEmailInput) { ;
__p += '\n    <h1>' +
((__t = ( data.signInTitle )) == null ? '' : __t) +
'</h1>\n    <div class="form-group">\n        <label for="email">' +
((__t = ( strings.login.email )) == null ? '' : __t) +
'</label>\n        <input spellcheck="false" id="email" name="email" type="email" class="form-control input-lg" placeholder="' +
((__t = ( strings.login.email )) == null ? '' : __t) +
'" value="' +
((__t = ( data.email )) == null ? '' : __t) +
'" />\n        <div class="email-error alert-danger hidden" role="alert"></div>\n    </div>\n    ';
 } else { ;
__p += '\n    <h1>' +
((__t = ( strings.login.welcomeToPazien )) == null ? '' : __t) +
'</h1>\n    ';
 } ;
__p += '\n\n    ';
 if (data.showPasswordInput) { ;
__p += '\n    <div class="form-group login-password">\n        <label for="password">' +
((__t = ( strings.login.password )) == null ? '' : __t) +
'</label>\n        <input spellcheck="false" id="password" name="password" type="password" class="form-control input-lg" placeholder="' +
((__t = ( strings.login.password )) == null ? '' : __t) +
'">\n        <span class="showPassword" data-controls="#password" data-toggle="tooltip" title="' +
((__t = ( strings.login.showPasswordTooltip )) == null ? '' : __t) +
'"><i class="far fa-eye"></i></span>\n        <div class="pass-error alert-danger hidden" role="alert"></div>\n    </div>\n    ';
 } ;
__p += '\n\n    ';
 if (data.showHowToSignInWithSSO) { ;
__p += '\n    <div class="step2-instructions">\n        ' +
((__t = ( data.howToSignInText )) == null ? '' : __t) +
' <a rel="noopener noreferrer" class="sso-redirect-link" style="cursor: pointer;">click here</a>\n    </div>\n    ';
 } ;
__p += '\n\n    <div class="submit-btn-block">\n    ';
 if (data.showNextButton) { ;
__p += '\n    <button class="btn btn-lg btn-primary btn-step">' +
((__t = ( strings.login.next )) == null ? '' : __t) +
'</button>\n    ';
 } else if (data.howToSignInText) { ;
__p += '\n    ';
 } else { ;
__p += '\n    <button class="btn btn-lg btn-primary btn-last-step">' +
((__t = ( data.signInButtonText ? data.signInButtonText : strings.login.signIn )) == null ? '' : __t) +
'</button>\n    ';
 } ;
__p += '\n    </div>\n</form>\n\n<div class="help-text-login">\n    ';
 if (data.step === 2) { ;
__p += '\n    <div><a href="#" class="not-me">' +
((__t = ( strings.login.thisIsNotMe )) == null ? '' : __t) +
'</a></div>\n    ';
 } ;
__p += '\n\n    ';
 if (data.isPazienUser) { ;
__p += '\n    <div><a href="/merchant/reset" class="reset-pass">' +
((__t = ( strings.login.resetPassword )) == null ? '' : __t) +
'</a></div>\n    ';
 } ;
__p += '\n\n    ';
 if (data.step === 1 || (data.step === 2 && data.isPazienUser === false && data.isSsoUser === false)) { ;
__p += '\n    <div><a href="#" class="trouble-sign-in">' +
((__t = ( strings.login.troubleSignIn )) == null ? '' : __t) +
'</a></div>\n    ';
 } ;
__p += '\n</div>\n';
return __p
}